import { render } from "./DrawerModal2.vue?vue&type=template&id=496d6b32&scoped=true"
import script from "./DrawerModal2.vue?vue&type=script&lang=js"
export * from "./DrawerModal2.vue?vue&type=script&lang=js"

import "./DrawerModal2.vue?vue&type=style&index=0&id=496d6b32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496d6b32"]])

export default __exports__